module.exports = __webpack_public_path__ + "static/media/apple1.0250a3de.png";